import { useMemo } from 'react';

import useGetOrganizationPropertiesQuery from '@/modules/core/hooks/useGetOrganizationProperties.query';

import { FieldLevelAccessValue } from '../../role.types';

const initialPropertiesBuilder = (propertiesKeys: string[]): { [key: string]: FieldLevelAccessValue } => {
  return propertiesKeys.reduce((acc, key) => {
    acc[key] = FieldLevelAccessValue.View;
    return acc;
  }, {} as { [key: string]: FieldLevelAccessValue });
};

export const useDefaultPropertiesValues = () => {
  const { properties, overridableProperties, isLoading: propLoading } = useGetOrganizationPropertiesQuery();

  const preparedProperties = useMemo(
    () => properties ? initialPropertiesBuilder(Object.keys(properties)) : undefined,
    [properties]);
  const preparedOverridableProperties = useMemo(
    () => overridableProperties ? initialPropertiesBuilder(Object.keys(overridableProperties)) : undefined,
    [overridableProperties]);

  return {
    preparedProperties,
    preparedOverridableProperties,
    propLoading,
  };
};
